// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__32BT5","label":"styles_label__37it0"};